import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import "components/common/DatePicker.css";
import SalesPersonSelect from "components/common/SalesPersonSelect";
import serialize from "form-serialize";
import * as moment from "moment";
import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RouteComponentProps } from "react-router";
import { scroller } from "react-scroll";
import MaskedInput from "react-text-mask";
import apifetch from "utils/apifetch";
import createNumberMask from "utils/createNumberMask";
import extractErrorMessage from "utils/extractErrorMessage";
import normalizePrice from "utils/normalizePrice";


interface State {
    bidDate?: moment.Moment;
    hasValidationErrors: boolean;
    errorMessage?: string;
    files: any[];
}

export default class Add extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    public constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            hasValidationErrors: false,
            errorMessage: undefined,
            files: [],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBidDateChanged = this.handleBidDateChanged.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/jobs-bqs">Projects</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Add New Project</BreadcrumbLink>
                    </Breadcrumb>
                    <div className="card card--form">
                        <div className="card-block">
                            <form
                                id="add-job"
                                name="form"
                                className="form"
                                onSubmit={this.handleSubmit}
                            >
                                <h3 className="block-title">New Project Details</h3>
                                <div className="form-wrapper">
                                    {this.state.hasValidationErrors && (
                                        <DangerAlert name="dangerAlert">
                                            {this.state.errorMessage || "An error occurred."}
                                        </DangerAlert>
                                    )}
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">CIS #</span>
                                            <input
                                                type="text"
                                                name="cisNumber"
                                                className="form-control"
                                                id="cis-id"
                                                maxLength={50}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6 d-flex align-items-center">
                                            <span className="field-label me-2">Bid Date</span>
                                            <div className="w-100" style={{ marginLeft: '33px' }}>
                                                <DatePicker
                                                    name="bidDate"
                                                    selected={this.state.bidDate}
                                                    onChange={this.handleBidDateChanged}
                                                    dateFormat="LL"
                                                    className="form-control"
                                                    popperPlacement="bottom"
                                                    popperModifiers={{
                                                        flip: {
                                                            behavior: ["bottom"],
                                                        },
                                                        preventOverflow: {
                                                            enabled: false,
                                                        },
                                                        hide: {
                                                            enabled: false,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Type</span>
                                            <select
                                                name="jobTypeId"
                                                id="type"
                                                className="form-control select2-single"
                                            >
                                                <option value="">Select a type</option>
                                                <option value="1">Public</option>
                                                <option value="2">Private</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Project Name</span>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            id="job-name"
                                            required
                                            onInput={(e) => e.currentTarget.setCustomValidity("")}
                                            onInvalid={(e) =>
                                                e.currentTarget.setCustomValidity(
                                                    "Project name is required."
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Description</span>
                                        <textarea
                                            name="description"
                                            id="description"
                                            rows={6}
                                            className="form-control"
                                        ></textarea>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-4">
                                            <span className="field-label">Estimated Cost</span>
                                            <MaskedInput
                                                mask={numberMask}
                                                name="costEstimate"
                                                className="form-control"
                                                id="estimated-cost"
                                            />
                                        </div>
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Address</span>
                                        <input
                                            type="text"
                                            name="address"
                                            className="form-control"
                                            id="address"
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Address 2</span>
                                        <input
                                            type="text"
                                            name="address2"
                                            className="form-control"
                                            id="address"
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">City</span>
                                        <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            id="city"
                                            autoComplete="new-password"
                                            maxLength={50}
                                            required
                                            onInput={(e) => e.currentTarget.setCustomValidity("")}
                                            onInvalid={(e) =>
                                                e.currentTarget.setCustomValidity("City is required.")
                                            }
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">State</span>
                                        <input
                                            type="text"
                                            name="state"
                                            className="form-control"
                                            id="state"
                                            autoComplete="new-password"
                                            pattern="[A-Za-z]{2}"
                                            maxLength={2}
                                            onInput={(e) => e.currentTarget.setCustomValidity("")}
                                            onInvalid={(e) =>
                                                e.currentTarget.setCustomValidity(
                                                    "State must be a 2 character abbreviation."
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">County</span>
                                        <input
                                            type="text"
                                            name="county"
                                            className="form-control"
                                            id="county"
                                            maxLength={50}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Salesperson</span>
                                        <SalesPersonSelect
                                            name="salesPerson"
                                            className="form-control"
                                            id="salespersion-id"
                                            maxLength={50}
                                        />
                                    </div>
                                    <br />
                                    <div className="form-actions">
                                        <div className="text-center">
                                            <button type="submit" className="btn btn-primary">
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        document.title = "Add New Project - " + SITE_NAME;
    }

    private async handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
                errorMessage: undefined,
            });
        }

        let data = serialize(e.currentTarget, { hash: true }) as any;

        // Normalize estimated cost to 0000.00
        if (data.costEstimate) {
            data.costEstimate = normalizePrice(data.costEstimate);
        }

        let response = await apifetch(
            "jobs",
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: JSON.stringify(data),
            },
            true
        );
        if (response.ok) {
            let responseData = await response.json();
            this.props.history.push("/jobs-bqs/" + responseData.id);
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                hasValidationErrors: true,
                errorMessage: errorText,
            });
            scroller.scrollTo("dangerAlert", {
                duration: 1500,
                delay: 100,
                smooth: true,
            });
        }
    }

    private handleBidDateChanged(date: moment.Moment) {
        this.setState({
            bidDate: date,
        });
    }

    private onDrop(acceptedFiles: any, rejectedFiles: any) { }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/Add.tsx